export default __webpack_public_path__ + "static/media/loader.5c9017b3.gif";